import { useGetApiAdminCompanies } from '@sit/client-shared';
import Divider from 'carbon-react/lib/components/divider';
import Loader from 'carbon-react/lib/components/loader/__next__';
import Typography from 'carbon-react/lib/components/typography';
import { CompaniesTable } from './CompaniesTable';

export function CompaniesPage() {
  const { data: companies, isPending } = useGetApiAdminCompanies({});

  return (
    <div className="intacct-admin">
      <Typography variant="h1">Companies</Typography>
      <Divider type="horizontal" mt={2} mb={2} />
      <div className="intacct-admin-inner-container">
        {isPending || !companies ? (
          <Loader showLabel={false} loaderType="ring" />
        ) : (
          <CompaniesTable companies={companies} />
        )}
      </div>
    </div>
  );
}
